import * as Moment from 'moment'
import * as React from 'react'
import './styles.css'

const year = Moment().format('YYYY')
export const Footer = () => <div className="display-flex footer">
  <span>&copy; 2015 - {year} rasa.io</span>
</div>



// WEBPACK FOOTER //
// ./src/components/footer/component.tsx